<template>
  <div class="experiment ma-0">
    
    <div>
      <div class='my-2 title d-flex'>
        <span><v-img width="30px" :src='api.school_logo_url' /></span>
        <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chi_name }} </span>
        <span v-else class='ml-2'> {{ api.school_name }} </span>
      </div>
    <router-view v-if="loaded"></router-view>
    </div>
    <v-overlay absolute :value="initialize">
      <v-progress-circular
        :size="50"
        :width="5"
        color="green accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import ExperimentBasic from "@/services/ExperimentBasic";

import {api_booking} from '@/services/iot/api_booking';
const apiBookingService = new api_booking(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      name: "",
      role: null,
      drawer: true,
      initialize: true,
      loaded: false,
      mini: true,
      school_id: "",
      api:{
        school_id: null,
        school_name: null,
        school_chi_name: null,
        school_logo_url: '',
      },      
    };
  },
  mounted: function () {
    this.name = 'iot';
    this.school_id = this.$route.params.school_id;

    var self = this;
        
    setTimeout(function(){
      if(self.$route.name == 'experiment'){
        console.log(self.$route.name);
      }
      else {
        console.log(self.$route.name);
        clearInterval(self.kick_inte);
      }
      self.initialization();
    },1000);
  },
  methods: {
    updateKickTime(time) {
      this.$emit("kickTime", (parseInt(time)*1000 - new Date().getTime())/1000);
    },
    initialization(){
      var self = this;
      apiBookingService.getSchool(self.school_id)
      .then((response) => {
        if(response.status=='success') {
          self.api.school_id = response.school;
          self.api.school_name = response.school_name;
          self.api.school_chi_name = response.school_chi_name;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          self.loaded = true;
          self.initialize = false;
        }
        else {
          self.initialize = false;
          alert(response.error);
        }
      });
    },    
  },
  destroyed(){
    clearInterval(this.kick_inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>